//======> Docementation <== ====//
registerBlockType("tornado/aboutus-section1", {
  title: __("About Us First Section", "tornado"),
  description: __("عن الشركة الجزء الأول", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    featImgAbout: {
      type: "string",
      default: null,
    },
    head: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    body: {
      type: "string",
    },
    body2: {
      type: "string",
    },
    link: {
      type: "string",
      selector: ".link",
      default: "",
    },
    titlelink: {
      type: "string",
      selector: ".titlelink",
      default: __("قراءة المزيد", "tornado"),
    },
    btn_control: {
      type: "string",
      default: "disable",
    },
  },
  //==== Editing Mode ====//
  edit: (props) => {
    //==== Block Data ====//
    const { attributes, setAttributes } = props;
    props.setAttributes( { align: 'full' } );
    function onChangefeatImg(newIMG) {
      setAttributes({ featImgAbout: newIMG.sizes.full.url });
    }
    function set_head(newhead) {
      setAttributes({ head: newhead });
    }
    const set_body1 = (body) => {
      setAttributes({ body });
    };
    const set_body2 = (body2) => {
      setAttributes({ body2 });
    };
    const set_BTN = (btn) => {
      setAttributes({ btn });
    };
    const set_BTN_link = (btnLInk) => {
      setAttributes({ btnLInk });
    };
    const set_btn_control = (btn_control) => {
      setAttributes({ btn_control });
    };
    const set_link = (link) => {
      setAttributes({ link });
    };
    const onChangeTitleLink = (titlelink) => {
      setAttributes({ titlelink });
    };

    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p>Select The Image !</p>
            <MediaUpload
              onSelect={onChangefeatImg}
              value={attributes.featImgAbout}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />
              <div className="section-medium hero-section ">

                          <img src= {attributes.featImgAbout} />

              </div>
                  
          </PanelBody>
          <PanelBody>
            <SelectControl
              key="btn_control"
              label="اظهار / اخفاء الزرار"
              value={attributes.btn_control}
              options={[
                { label: "Show", value: "enable" },
                { label: "Hide", value: "disable" },
              ]}
              onChange={set_btn_control}
            />
            {attributes.btn_control === "enable" && (
              <TextControl
                className="titlelink"
                label={__("Button Title", "tornado")}
                onChange={onChangeTitleLink}
                value={attributes.titlelink}
              />
            )}
            {attributes.btn_control === "enable" && (
              <TextControl
                className="link"
                label={__("Button Link", "tornado")}
                onChange={set_link}
                value={attributes.link}
              />
            )}
           
          </PanelBody>
        </InspectorControls>

        <div class="section-medium hero-section primary-bg" data-src={attributes.featImgAbout}>         
          <div class="container white-color">
            <div class="row align-end-x content large overflow">
              <div
                class="col-12 col-m-7 col-l-6 view-status"
                data-animation="fadeInEnd"
              >
                <RichText
                  // key="editable"
                  tagName="h3"
                  className="mb15"
                  placeholder="عن ألما لصناعة الزجاج والألومنيوم"
                  value={attributes.head}
                  onChange={set_head}
                />
                <RichText
                  key="editable"
                  tagName="p"
                  placeholder="ومن هنا وجب على المصمم أن يضع نصوصا مؤقتة على التصميم ليظهر للعميل الشكل كاملاً،دور مولد النص العربى أن يوفر على المصمم عناء البحث عن نص بديل لا علاقة له بالموضوع الذى يتحدث عنه التصميم فيظهر بشكل لا يليق."
                  value={attributes.body}
                  onChange={set_body1}
                />
                <RichText
                  key="editable2"
                  tagName="p"
                  placeholder="ومن هنا وجب على المصمم أن يضع نصوصا مؤقتة على التصميم ليظهر للعميل الشكل كاملاً،دور مولد النص العربى أن يوفر على المصمم عناء البحث عن نص بديل لا علاقة له بالموضوع الذى يتحدث عنه التصميم فيظهر بشكل لا يليق."
                  value={attributes.body2}
                  onChange={set_body2}
                />
                {attributes.btn_control === "enable" && (
                  <a
                    href={attributes.link}
                    className="more ti-arrow-left-c with-line mt20"
                  >
                    {attributes.titlelink}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </Panel>
    );
  },
  //==== Puplish Mode ====//
  save: (props) => {
    const { attributes } = props;
    // <!-- About Us -->
    return (
      <div class="section-medium hero-section primary-bg" data-src={attributes.featImgAbout}>
        <div class="container white-color">
          <div class="row align-end-x content large overflow">
            <div
              class="col-12 col-m-7 col-l-6 view-status"
              data-animation="fadeInEnd"
            >
  <RichText.Content className="mb15" tagName="h3" value={attributes.head} />
                <p>{attributes.body}</p>
                <RichText.Content  tagName="p" value={attributes.body2} />
              {attributes.btn_control === 'enable' && <a href={attributes.link}    className="more ti-arrow-left-c with-line mt20">{attributes.titlelink}</a>}

            </div>
          </div>
        </div>
      </div>
    );
    // <!-- // About Us -->
  },
});
